
/* ===== DSC Delivery Props Helper (safe) ===== */
(function(){
  if (window.getDSCDeliveryPropsFromDOM) return;

  window.getDSCDeliveryPropsFromDOM = function(scopeEl){
    try {
      var scope = scopeEl && (scopeEl.closest && (scopeEl.closest("[data-section-id]") || scopeEl.closest("section"))) || document;
      function val(sel){
        var el = scope.querySelector(sel) || document.querySelector(sel);
        return el && el.value ? el.value : "";
      }
      var range = val('input[name="properties[_Delivery range]"]');
      var start = val('input[name="properties[_Delivery start]"]');
      var end   = val('input[name="properties[_Delivery end]"]');

      // fallback to non-underscore keys if store uses them
      if (!range) range = val('input[name="properties[Delivery range]"]');
      if (!start) start = val('input[name="properties[Delivery start]"]');
      if (!end)   end   = val('input[name="properties[Delivery end]"]');

      var props = {};
      if (range) props["_Delivery range"] = range;
      if (start) props["_Delivery start"] = start;
      if (end)   props["_Delivery end"] = end;

      // also provide non-underscore as backup (won't hurt)
      if (range) props["Delivery range"] = range;
      if (start) props["Delivery start"] = start;
      if (end)   props["Delivery end"] = end;

      return props;
    } catch(e){
      return {};
    }
  };
})();

(function () {
  /* ------------------ Helpers ------------------ */
  const qs = (el, s) => (el ? el.querySelector(s) : null);
  const qsa = (el, s) => (el ? Array.from(el.querySelectorAll(s)) : []);
  const norm = (v) => String(v || "").trim();

  const safeJson = (el, fb) => {
    try {
      return el ? JSON.parse(el.textContent || "") : fb;
    } catch {
      return fb;
    }
  };

  const escapeHtml = (str) =>
    String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const uniq = (arr) => Array.from(new Set(arr));

  const money = (() => {
    let nf = null;
    let lastCur = null;
    return (cents) => {
      if (!Number.isFinite(+cents)) return "";
      if (window.Shopify?.formatMoney) {
        try {
          return Shopify.formatMoney(cents, Shopify.money_format);
        } catch {}
      }
      try {
        const cur = window.Shopify?.currency?.active || "INR";
        if (!nf || lastCur !== cur) {
          nf = new Intl.NumberFormat("en-IN", { style: "currency", currency: cur });
          lastCur = cur;
        }
        return nf.format(cents / 100);
      } catch {
        return (cents / 100).toFixed(2);
      }
    };
  })();

  const buildVariantIndex = (variants) => {
    const m = new Map();
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const k = [v.option1, v.option2, v.option3].map(norm).join("|||");
      m.set(k, v);
    }
    return m;
  };

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  /* ------------------ XHR add-to-cart + retry/backoff ------------------ */
  function xhrAddToCart(formData) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", window.Shopify.routes.root + "cart/add.js", true);
      xhr.setRequestHeader("Accept", "application/json");

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText || "{}"));
          } catch {
            resolve({});
          }
          return;
        }
        let msg = "Add to cart failed.";
        try {
          const data = JSON.parse(xhr.responseText || "{}");
          msg = data.description || data.message || msg;
        } catch {}
        const err = new Error(msg);
        err.status = xhr.status;
        reject(err);
      };

      xhr.onerror = function () {
        const err = new Error("Network error while adding to cart.");
        err.status = 0;
        reject(err);
      };

      xhr.send(formData);
    });
  }

  async function addSingleVariantWithRetry(payload, { maxRetries = 4 } = {}) {
    let attempt = 0;
    while (true) {
      try {
        const fd = new FormData();
        fd.append("id", String(payload.id));
        fd.append("quantity", String(payload.quantity || 1));

        const props = payload.properties || {};
        const dProps = window.getDSCDeliveryPropsFromDOM();
        if (dProps) {
          for (const [k, v] of Object.entries(dProps)) {
            if (props[k] == null || String(props[k]).trim() === '') props[k] = v;
          }
        }
        for (const [k, v] of Object.entries(props)) {
          if (v == null) continue;
          const val = String(v).trim();
          if (!val) continue;
          fd.append(`properties[${k}]`, val);
        }

        const files = payload.files || {};
        for (const [k, file] of Object.entries(files)) {
          if (!file) continue;
          fd.append(`properties[${k}]`, file);
        }

        return await xhrAddToCart(fd);
      } catch (err) {
        attempt += 1;
        const status = err && err.status;
        if (attempt <= maxRetries && (status === 409 || status === 429 || status === 0)) {
          await sleep(250 * attempt);
          continue;
        }
        throw err;
      }
    }
  }

  /* ------------------ UI Builders ------------------ */
  function groupHTML(i, title) {
    return `
      <div class="dsc-mvp__group" data-group="${i}">
        <div class="dsc-mvp__group-head">
          <div class="dsc-mvp__group-title">${escapeHtml(title)}</div>
          <div class="dsc-mvp__group-actions">
            <button type="button" class="dsc-mvp__group-add" aria-label="Add more in group">+</button>
          </div>
        </div>
        <div class="dsc-mvp__group-rows"></div>
      </div>
    `;
  }

  function rowHTML(groupTitle, rowIndex, optionCount, labels) {
    const field = (k, l) => `
      <div class="dsc-mvp__field" data-opt-field="${escapeHtml(k)}">
        <div class="dsc-mvp__label">${escapeHtml(l)}</div>
        <select class="dsc-mvp__select" data-opt="${k}"></select>
      </div>
    `;

    return `
      <div class="dsc-mvp__row" data-row="${rowIndex}">
        <div class="dsc-mvp__row-head">
          <div class="dsc-mvp__row-label">${escapeHtml(groupTitle)} ${rowIndex + 1}</div>
          <div class="dsc-mvp__row-meta">
            <span class="dsc-mvp__price-value"></span>
            <button type="button" class="dsc-mvp__row-add" aria-label="Add more">Add More</button>
            <button type="button" class="dsc-mvp__remove" aria-label="Remove">×</button>
          </div>
        </div>

        <div class="dsc-mvp__row-grid">
          ${field("option1", labels[0] || "Option 1")}
          ${optionCount >= 2 ? field("option2", labels[1] || "Option 2") : ""}
          ${optionCount >= 3 ? field("option3", labels[2] || "Option 3") : ""}
        </div>
      </div>
    `;
  }

  // Global Color (pill UI) — only when shared option1 is enabled
  function sharedPillsHTML(label, values) {
    const pills = (values || [])
      .map((v, idx) => {
        const safeV = escapeHtml(v);
        return `<button type="button" class="dsc-mvp__pill" role="radio" aria-checked="${idx === 0 ? "true" : "false"}" data-value="${safeV}">${safeV}</button>`;
      })
      .join("");

    const selectOptions = (values || [])
      .map((v, idx) => `<option value="${escapeHtml(v)}"${idx === 0 ? " selected" : ""}>${escapeHtml(v)}</option>`)
      .join("");

    return `
      <div class="dsc-mvp__shared" aria-live="polite">
        <div class="dsc-mvp__shared-head">
          <div class="dsc-mvp__shared-title">${escapeHtml(label)}</div>
        </div>

        <div class="dsc-mvp__pills" role="radiogroup" aria-label="${escapeHtml(label)}">
          ${pills}
        </div>

        <!-- hidden select kept for internal logic -->
        <select class="dsc-mvp__select dsc-mvp__shared-select" data-shared="option1" tabindex="-1" aria-hidden="true">
          ${selectOptions}
        </select>
      </div>
    `;
  }

  /* ------------------ Loader markup + toggles ------------------ */
  const SPINNER_SVG = `
    <svg viewBox="0 0 50 50" aria-hidden="true" focusable="false">
      <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="6"></circle>
      <path d="M45 25c0-11.046-8.954-20-20-20" fill="none" stroke="currentColor" stroke-width="6"></path>
    </svg>
  `;

  function ensureButtonLoader(btn) {
    if (!btn) return;
    if (qs(btn, ".dsc-mvp__btn-text") && qs(btn, ".dsc-mvp__btn-spinner")) return;

    const text = btn.textContent || "";
    btn.textContent = "";

    const textSpan = document.createElement("span");
    textSpan.className = "dsc-mvp__btn-text";
    textSpan.textContent = text;

    const spinner = document.createElement("span");
    spinner.className = "dsc-mvp__btn-spinner";
    spinner.innerHTML = SPINNER_SVG;

    btn.appendChild(textSpan);
    btn.appendChild(spinner);
  }

  function setBtnLoading(btn, isLoading) {
    if (!btn) return;
    btn.classList.toggle("is-loading", !!isLoading);
    btn.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  /* ------------------ Rules helpers ------------------ */
  function normalizeRules(rulesObj) {
    const out = {};
    if (!rulesObj || typeof rulesObj !== "object") return out;

    for (const [groupName, rule] of Object.entries(rulesObj)) {
      if (!groupName) continue;
      const g = norm(groupName);
      const r = rule && typeof rule === "object" ? rule : {};
      const o1 = Array.isArray(r.option1) ? r.option1.map(norm).filter(Boolean) : null;
      const o2 = Array.isArray(r.option2) ? r.option2.map(norm).filter(Boolean) : null;
      const o3 = Array.isArray(r.option3) ? r.option3.map(norm).filter(Boolean) : null;
      out[g] = { option1: o1, option2: o2, option3: o3 };
    }
    return out;
  }

  function filterVariantsByRule(variants, rule, optCount) {
    const allow1 = rule?.option1 ? new Set(rule.option1) : null;
    const allow2 = optCount >= 2 && rule?.option2 ? new Set(rule.option2) : null;
    const allow3 = optCount >= 3 && rule?.option3 ? new Set(rule.option3) : null;

    const out = [];
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const o1 = norm(v.option1);
      const o2 = optCount >= 2 ? norm(v.option2) : "";
      const o3 = optCount >= 3 ? norm(v.option3) : "";

      if (allow1 && !allow1.has(o1)) continue;
      if (allow2 && !allow2.has(o2)) continue;
      if (allow3 && !allow3.has(o3)) continue;

      out.push(v);
    }
    return out;
  }

  function buildGroupOptionMaps(groupVariants, optCount) {
    const opt1Values = uniq(groupVariants.map((v) => norm(v.option1)).filter(Boolean));

    const opt2ByOpt1 = new Map();
    const opt3ByOpt1Opt2 = new Map();

    if (optCount >= 2) {
      for (let i = 0; i < groupVariants.length; i++) {
        const v = groupVariants[i];
        const o1 = norm(v.option1);
        const o2 = norm(v.option2);
        if (!o1 || !o2) continue;
        if (!opt2ByOpt1.has(o1)) opt2ByOpt1.set(o1, []);
        opt2ByOpt1.get(o1).push(o2);
      }
      for (const [k, arr] of opt2ByOpt1.entries()) opt2ByOpt1.set(k, uniq(arr));
    }

    if (optCount >= 3) {
      for (let i = 0; i < groupVariants.length; i++) {
        const v = groupVariants[i];
        const o1 = norm(v.option1);
        const o2 = norm(v.option2);
        const o3 = norm(v.option3);
        if (!o1 || !o2 || !o3) continue;
        const key = `${o1}|||${o2}`;
        if (!opt3ByOpt1Opt2.has(key)) opt3ByOpt1Opt2.set(key, []);
        opt3ByOpt1Opt2.get(key).push(o3);
      }
      for (const [k, arr] of opt3ByOpt1Opt2.entries()) opt3ByOpt1Opt2.set(k, uniq(arr));
    }

    return { opt1Values, opt2ByOpt1, opt3ByOpt1Opt2 };
  }

  
  function setSelectOptions(selectEl, values, keepValue) {
    if (!selectEl) return;

    const safe = Array.isArray(values) ? values.filter(Boolean) : [];
    const sig = safe.join("|||");

    const wanted = norm(keepValue);
    const prev = wanted && safe.includes(wanted) ? wanted : safe[0] || "";

    // If options list hasn't changed, only ensure value is correct.
    if (selectEl.dataset.dscSig === sig) {
      if (prev && selectEl.value !== prev) selectEl.value = prev;
      return;
    }
    selectEl.dataset.dscSig = sig;

    // Rebuild options (fast + minimal reflow)
    selectEl.textContent = "";
    const frag = document.createDocumentFragment();
    for (let i = 0; i < safe.length; i++) {
      const opt = document.createElement("option");
      opt.value = safe[i];
      opt.textContent = safe[i];
      frag.appendChild(opt);
    }
    selectEl.appendChild(frag);
    if (prev) selectEl.value = prev;
  }

  /* ------------------ Preset resolver ------------------ */
  function resolvePreset(root) {
    const presetKey = safeJson(qs(root, ".dsc-mvp__preset_key"), "");
    if (!presetKey) return null;

    const presets = safeJson(qs(root, ".dsc-mvp__presets"), {});
    if (!presets || typeof presets !== "object") return null;

    const p = presets[presetKey];
    if (!p || typeof p !== "object") return null;
    return { key: presetKey, preset: p };
  }
  
/*dsc custom fields*/

  function dscRenderCustomFields(root, insertBeforeEl) {
    const tagsEl = root.querySelector('.dsc-mvp__product_tags');
    const presetsEl = root.querySelector('.dsc-mvp__fields_presets');
    if (!tagsEl || !presetsEl) return null;

    let tags = [];
    let presets = {};
    try { tags = JSON.parse(tagsEl.textContent || '[]'); } catch (e) {}
    try { presets = JSON.parse(presetsEl.textContent || '{}'); } catch (e) {}
    if (!Array.isArray(tags) || !presets || typeof presets !== 'object') return null;

    // Find tag: dsc-mvp:fields=...
    const fieldTag = tags.find(t => typeof t === 'string' && t.indexOf('dsc-mvp:fields=') === 0);
    if (!fieldTag) return null;

    const keyStr = fieldTag.split('dsc-mvp:fields=')[1] || '';
    const keys = keyStr.split(',').map(s => (s || '').trim()).filter(Boolean);
    if (!keys.length) return null;

    // Build fields list (presets can contribute multiple fields)
    const fieldsToRender = [];
    keys.forEach(k => {
      const p = presets[k];
      if (!p || !Array.isArray(p.fields)) return;
      p.fields.forEach(f => fieldsToRender.push(f));
    });
    if (!fieldsToRender.length) return null;

    // Render container BELOW MVP content, but ABOVE action buttons if possible
    let holder = root.querySelector('.dsc-mvp__custom-fields');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'dsc-mvp__custom-fields';
      const anchor = insertBeforeEl || null;
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(holder, anchor);
      } else {
        root.appendChild(holder);
      }
    }

    const esc = (s) => String(s || '')
      .replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;')
      .replaceAll('"','&quot;').replaceAll("'","&#039;");

    holder.innerHTML = `
        <div class="dsc-mvp__custom-fields-grid">
        ${fieldsToRender.map((f, idx) => {
          const label = esc(f.label || 'Custom field');
          const key = esc(f.property_key || f.label || `Custom ${idx + 1}`);
          const ph = esc(f.placeholder || '');
          const req = f.required ? 'required' : '';
          const max = f.max ? `maxlength="${Number(f.max)}"` : '';
          const name = `properties[${key}]`;

          const type = (f.type || 'text').toLowerCase();

          if (type === 'textarea') {
            return `
              <label class="dsc-mvp__cf">
                <div class="dsc-mvp__cf-label">${label}${f.required ? ' *' : ''}</div>
                <textarea class="dsc-mvp__cf-input" name="${name}" placeholder="${ph}" ${req} ${max}></textarea>
              </label>
            `;
          }

          if (type === 'file') {
            const accept = esc(f.accept || 'image/*');
            const minFiles = Number(f.min_files || (f.required ? 1 : 0));
            const maxFiles = Number(f.max_files || 1);
            const multiple = maxFiles > 1 ? 'multiple' : '';

            return `
              <label class="dsc-mvp__cf">
                <div class="dsc-mvp__cf-label">${label}${f.required ? ' *' : ''}</div>
                <input
                  class="dsc-mvp__cf-input dsc-mvp__cf-file"
                  type="file"
                  name="${name}"
                  accept="${accept}"
                  ${req}
                  ${multiple}
                  data-min-files="${minFiles}"
                  data-max-files="${maxFiles}"
                />
                <div class="dsc-mvp__cf-help">
                  ${maxFiles > 1 ? `Upload ${minFiles} to ${maxFiles} image(s)` : 'Upload 1 image'}
                </div>
              </label>
            `;
          }

          return `
            <label class="dsc-mvp__cf">
              <div class="dsc-mvp__cf-label">${label}${f.required ? ' *' : ''}</div>
              <input class="dsc-mvp__cf-input" type="text" name="${name}" placeholder="${ph}" ${req} ${max} />
            </label>
          `;
        }).join('')}
      </div>
    `;

    return holder;
  }


  function dscCollectNativeFiles(root) {
    const holder = root.querySelector('.dsc-mvp__custom-fields');
    if (!holder) return {};

    const out = {};

    holder.querySelectorAll('input[type="file"][name^="properties["]').forEach((el) => {
      const n = String(el.getAttribute('name') || '');
      const m = n.match(/^properties\[(.*)\]$/);
      if (!m) return;

      const key = (m[1] || '').trim();
      if (!key) return;

      const files = Array.from(el.files || []);
      if (!files.length) return;

      // Shopify requires separate property keys for multiple uploaded files
      if (files.length === 1) {
        out[key] = files[0];
      } else {
        files.slice(0, 5).forEach((file, index) => {
          out[`${key} ${index + 1}`] = file;
        });
      }
    });

    return out;
  }

  function dscCollectCustomFieldProperties(root) {
    const holder = root.querySelector('.dsc-mvp__custom-fields');
    if (!holder) return {};

    const out = {};
    const fields = holder.querySelectorAll('input:not([type="file"])[name^="properties["], textarea[name^="properties["]');
    fields.forEach((el) => {
      const n = String(el.getAttribute('name') || '');
      const m = n.match(/^properties\[(.*)\]$/);
      if (!m) return;
      const key = (m[1] || '').trim();
      const val = String(el.value || '').trim();
      if (!key) return;
      if (!val) return; // don't attach empties
      out[key] = val;
    });
    return out;
  }

  function dscValidateCustomFields(root) {
    const holder = root.querySelector('.dsc-mvp__custom-fields');
    if (!holder) return { ok: true };

    const fields = holder.querySelectorAll('input, textarea');
    for (let i = 0; i < fields.length; i++) {
      const el = fields[i];
      if (el.disabled) continue;

      if (el.type === 'file') {
        const filesCount = el.files ? el.files.length : 0;
        const minFiles = Number(el.dataset.minFiles || (el.hasAttribute('required') ? 1 : 0));
        const maxFiles = Number(el.dataset.maxFiles || 1);

        if (filesCount < minFiles) {
          if (typeof el.setCustomValidity === 'function') el.setCustomValidity(`Please upload at least ${minFiles} image(s).`);
          if (typeof el.reportValidity === 'function') el.reportValidity();
          try { el.focus({ preventScroll: true }); } catch (_) { try { el.focus(); } catch (_) {} }
          if (typeof el.setCustomValidity === 'function') el.setCustomValidity('');
          return { ok: false };
        }

        if (filesCount > maxFiles) {
          if (typeof el.setCustomValidity === 'function') el.setCustomValidity(`You can upload maximum ${maxFiles} image(s).`);
          if (typeof el.reportValidity === 'function') el.reportValidity();
          try { el.focus({ preventScroll: true }); } catch (_) { try { el.focus(); } catch (_) {} }
          if (typeof el.setCustomValidity === 'function') el.setCustomValidity('');
          return { ok: false };
        }

        continue;
      }

      // Native constraint validation (required, maxlength, etc.)
      if (typeof el.checkValidity === 'function' && !el.checkValidity()) {
        if (typeof el.reportValidity === 'function') el.reportValidity();
        try { el.focus({ preventScroll: true }); } catch (_) { try { el.focus(); } catch (_) {} }
        return { ok: false };
      }

      // Extra: treat "required" with whitespace as empty
      if (el.hasAttribute('required')) {
        const v = String(el.value || '').trim();
        if (!v) {
          if (typeof el.reportValidity === 'function') el.reportValidity();
          try { el.focus({ preventScroll: true }); } catch (_) { try { el.focus(); } catch (_) {} }
          return { ok: false };
        }
      }
    }

    return { ok: true };
  }


  /* ------------------ Init ------------------ */
  function init(root) {
    const variants = safeJson(qs(root, ".dsc-mvp__variants"), []);
    if (!Array.isArray(variants) || !variants.length) return;

    const groupsWrap = qs(root, ".dsc-mvp__groups");
    const addBtn = qs(root, ".dsc-mvp__addcart");
    const checkoutBtn = qs(root, ".dsc-mvp__checkout");
    const errorEl = qs(root, ".dsc-mvp__error");
    if (!groupsWrap || !addBtn || !checkoutBtn || !errorEl) return;

    ensureButtonLoader(addBtn);
    ensureButtonLoader(checkoutBtn);

    const presetResolved = resolvePreset(root);
    const preset = presetResolved?.preset || null;

    // Metafields (may be empty arrays/objects)
    const groupLabelsMF = safeJson(qs(root, ".dsc-mvp__group_labels"), []);
    const optionLabelsMF = safeJson(qs(root, ".dsc-mvp__options_labels"), []);
    const groupRulesMF = safeJson(qs(root, ".dsc-mvp__group_rules"), {});
    const cfgMF = safeJson(qs(root, ".dsc-mvp__config"), {});

    // Fallback to preset when MF empty
    const groupLabels =
      (Array.isArray(groupLabelsMF) && groupLabelsMF.length ? groupLabelsMF : (preset?.picker_labels || []))
        .map((s) => norm(s))
        .filter(Boolean);

    const optionLabels =
      (Array.isArray(optionLabelsMF) && optionLabelsMF.length ? optionLabelsMF : (preset?.options_labels || []))
        .map((s) => norm(s))
        .filter(Boolean);

    const groupRulesRaw =
      (groupRulesMF && typeof groupRulesMF === "object" && Object.keys(groupRulesMF).length ? groupRulesMF : (preset?.group_variant_rules || {}));

    const rules = normalizeRules(groupRulesRaw);

    // Safety fallback
    const finalGroupLabels = groupLabels.length ? groupLabels : ["Product 1"];
    const finalOptionLabels = optionLabels.length ? optionLabels : ["Color", "Size"];

    // Limits
    const maxRowsOverall = Math.max(1, Number(root.dataset.maxRows || 20));
    const maxRowsPerGroup = Math.max(1, Number(root.dataset.maxRowsPerGroup || 20));
    const defaultRowsPerGroup = Math.max(1, Number(root.dataset.defaultRowsPerGroup || 1));

    const optCount = variants.some((v) => v.option3) ? 3 : variants.some((v) => v.option2) ? 2 : 1;

    // Shared options (global color)
    const sharedOptionsMF = Array.isArray(cfgMF?.shared_options) ? cfgMF.shared_options.map(norm).filter(Boolean) : [];
    const sharedModeMF = norm(cfgMF?.shared_mode || "");

    const sharedOptionsPreset = Array.isArray(preset?.shared_options) ? preset.shared_options.map(norm).filter(Boolean) : [];
    const sharedModePreset = norm(preset?.shared_mode || "");

    const sharedOptions = sharedOptionsMF.length ? sharedOptionsMF : sharedOptionsPreset;
    const sharedMode = (sharedModeMF || sharedModePreset || "strict").toLowerCase();

    const sharedOption1Enabled = sharedOptions.includes("option1") && optCount >= 1;

    const showError = (m) => {
      errorEl.hidden = !m;
      errorEl.textContent = m || "";
    };

    const state = {
      totalRows: 0,
      groups: [],
      rafQueued: false,
      displayRowEl: null, // last interacted row drives gallery
    };

    
/* ------------------ Theme sync: variant ONLY (gallerysync2 owns gallery) ------------------ */
const getProductScope = () => root.closest("product-info") || root.closest(".product") || document;

  /* ------------------ Delivery estimator properties (shared to cart + order) ------------------ */
  window.getDSCDeliveryPropsFromDOM = function() {
    try {
      const scope = getProductScope();
      const inputs = Array.from(scope.querySelectorAll('input[data-dsc-delivery-prop]'));
      if (!inputs.length) return null;

      const pick = (name) => {
        const el = inputs.find(i => i.getAttribute('name') === name);
        return el ? String(el.value || '').trim() : '';
      };

      const range = pick('properties[_Delivery range]');
      const start = pick('properties[_Delivery start]');
      const end = pick('properties[_Delivery end]');

      if (!range && !start && !end) return null;

      const props = {};
      if (range) props['_Delivery range'] = range;
      if (start) props['_Delivery start'] = start;
      if (end) props['_Delivery end'] = end;
      return props;
    } catch (e) {
      return null;
    }
  }

const findMainAddToCartForm = () => {
  const scope = getProductScope();
  const forms = Array.from(scope.querySelectorAll('form[action*="/cart/add"]'));
  return (
    forms.find((f) => String(f.id || "").startsWith("product-form-")) ||
    forms.find((f) => String(f.getAttribute("id") || "").includes("product-form")) ||
    forms[0] ||
    null
  );
};

const setMainVariantId = (variantId) => {
  const form = findMainAddToCartForm();
  if (!form) return;
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;

  const next = String(variantId);
  if (String(idInput.value) === next) return;

  idInput.value = next;

  // Wake up theme + gallerysync2 listeners
  idInput.dispatchEvent(new Event("change", { bubbles: true }));
  form.dispatchEvent(new Event("change", { bubbles: true }));

  // Nice-to-have: update URL variant param (no scrolling side-effects)
  try {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", next);
    window.history.replaceState({}, "", url.toString());
  } catch (_) {}
};

const scheduleRefresh = () => {
      if (state.rafQueued) return;
      state.rafQueued = true;
      requestAnimationFrame(() => {
        state.rafQueued = false;
        refreshRemoveAvailability();
        refreshAddAvailability();
      });
    };

    const refreshRemoveAvailability = () => {
      const canRemoveAny = state.totalRows > 1;
      for (let gi = 0; gi < state.groups.length; gi++) {
        const g = state.groups[gi];
        const rows = qsa(g.rowsWrap, ".dsc-mvp__row");
        for (let ri = 0; ri < rows.length; ri++) {
          const btn = qs(rows[ri], ".dsc-mvp__remove");
          if (!btn) continue;
          btn.disabled = !canRemoveAny;
          btn.style.display = canRemoveAny ? "" : "none";
        }
      }
    };

    const refreshAddAvailability = () => {
      const overallCanAdd = state.totalRows < maxRowsOverall;
      for (let gi = 0; gi < state.groups.length; gi++) {
        const g = state.groups[gi];
        const groupCanAdd = overallCanAdd && g.rowsCount < maxRowsPerGroup;

        if (g.groupAddBtn) g.groupAddBtn.disabled = !groupCanAdd;

        const rowAddBtns = qsa(g.rowsWrap, ".dsc-mvp__row-add");
        for (let i = 0; i < rowAddBtns.length; i++) rowAddBtns[i].disabled = !groupCanAdd;
      }
    };

    const refreshRowLabelsInGroup = (g) => {
      const title = g.titleEl?.textContent || "Product";
      const rows = qsa(g.rowsWrap, ".dsc-mvp__row");
      for (let i = 0; i < rows.length; i++) {
        const rowEl = rows[i];
        rowEl.dataset.row = String(i);
        const labelEl = qs(rowEl, ".dsc-mvp__row-label");
        if (labelEl) labelEl.textContent = `${title} ${i + 1}`;
      }
    };

    
    const getGroupStateFromRow = (rowEl) => {
      if (!rowEl) return null;

      // Fast path: cached pointer
      if (rowEl.__dscGroup && rowEl.__dscGroup.el) return rowEl.__dscGroup;

      const groupEl = rowEl.closest(".dsc-mvp__group");
      if (!groupEl) return null;

      // We attach __dscGroup on groupEl during init for O(1)
      const g = groupEl.__dscGroup || state.groups.find((x) => x.el === groupEl) || null;
      if (g) rowEl.__dscGroup = g;
      return g;
    };

    const getSharedOption1 = () => {
      if (!sharedOption1Enabled) return "";
      return norm(qs(root, '[data-shared="option1"]')?.value);
    };

    const getRowCache = (rowEl) => {
      if (rowEl && rowEl.__dsc) return rowEl.__dsc;

      const s1 = qs(rowEl, '[data-opt="option1"]');
      const s2 = optCount >= 2 ? qs(rowEl, '[data-opt="option2"]') : null;
      const s3 = optCount >= 3 ? qs(rowEl, '[data-opt="option3"]') : null;
      const priceEl = qs(rowEl, ".dsc-mvp__price-value");

      rowEl.__dsc = { s1, s2, s3, priceEl };
      return rowEl.__dsc;
    };

    const getVariantForRow = (rowEl) => {
      const g = getGroupStateFromRow(rowEl);
      if (!g) return null;

      const c = getRowCache(rowEl);

      const v1 = sharedOption1Enabled ? getSharedOption1() : norm(c.s1?.value);
      const v2 = optCount >= 2 ? norm(c.s2?.value) : "";
      const v3 = optCount >= 3 ? norm(c.s3?.value) : "";

      return g.vIndex.get([v1, v2, v3].join("|||")) || null;
    };

    const updatePrice = (rowEl) => {
      const v = getVariantForRow(rowEl);
      const c = getRowCache(rowEl);
      const p = c.priceEl;
      if (p) p.textContent = v ? money(v.price) : "";

      // If this row is the driver, sync main product variant + gallery
      if (!state.displayRowEl) state.displayRowEl = rowEl;
      if (state.displayRowEl === rowEl && v) setMainVariantId(v.id);
      scheduleSetPriceRender();
    };

    /* ------------------ Set Price Summary (Product page) ------------------ */
    let _setPriceRaf = 0;
    let _setPriceTarget = null;
    let _setPriceOriginal = null;
    let _setSummaryEl = null;

    const findSetPriceTarget = () => {
      if (_setPriceTarget) return _setPriceTarget;

      // Try to locate the main product price container (Spotlight / Dawn patterns)
      const scope =
        root.closest("product-info") ||
        root.closest("[data-section-id]") ||
        root.closest("section") ||
        document;

      // Prefer the canonical price wrapper by id
      let el = scope.querySelector('[id^="price-"]');
      if (el && el.closest(".dsc-mvp")) el = null;

      // Fallback: first .price in scope that is NOT inside the MVP UI
      if (!el) {
        const list = Array.from(scope.querySelectorAll(".price"));
        el = list.find((x) => x && !x.closest(".dsc-mvp"));
      }

      if (el) {
        _setPriceTarget = el;
        _setPriceOriginal = el.innerHTML;
      }
      return _setPriceTarget;
    };

    const computeSetTotals = () => {
      const rows = qsa(groupsWrap, ".dsc-mvp__row");
      let pieces = 0;
      let total = 0;

      for (let i = 0; i < rows.length; i++) {
        const v = getVariantForRow(rows[i]);
        if (!v) continue;
        pieces += 1;
        total += (v.price || 0);
      }
      return { pieces, total };
    };

    const renderSetPrice = () => {
      _setPriceRaf = 0;
      const priceEl = findSetPriceTarget();
      if (!priceEl) return;

      // Ensure local MVP summary element (above Add Selected button)
      if (!_setSummaryEl) {
        const actions = qs(root, ".dsc-mvp__actions");
        if (actions) {
          _setSummaryEl = qs(actions, ".dsc-mvp__set-summary");
          if (!_setSummaryEl) {
            _setSummaryEl = document.createElement("div");
            _setSummaryEl.className = "dsc-mvp__set-summary";
            _setSummaryEl.hidden = true;
            actions.insertBefore(_setSummaryEl, actions.firstChild);
          }
        }
      }

      const { pieces, total } = computeSetTotals();

      // If nothing selected, restore original theme price
      if (!pieces) {
        if (_setPriceOriginal != null) priceEl.innerHTML = _setPriceOriginal;
        if (_setSummaryEl) {
          _setSummaryEl.hidden = true;
          _setSummaryEl.textContent = "";
        }
        return;
      }

      const note = `(For set of ${pieces} piece${pieces > 1 ? "s" : ""})`;

      // Replace contents with a clean single-line summary (matches reference UI)
      priceEl.innerHTML = `
        <span class="price-item price-item--regular">${money(total)}</span>
        <span class="dsc-mvp__set-note"> ${escapeHtml(note)}</span>
      `.trim();

      // Also show the same summary above the Add Selected to cart button
      if (_setSummaryEl) {
        _setSummaryEl.hidden = false;
        _setSummaryEl.innerHTML = `
          <span class="dsc-mvp__set-total">${money(total)}</span>
          <span class="dsc-mvp__set-note"> ${escapeHtml(note)}</span>
        `.trim();
      }
    };

    const scheduleSetPriceRender = () => {
      if (_setPriceRaf) return;
      _setPriceRaf = requestAnimationFrame(renderSetPrice);
    };


    // cause: "init" | "opt1" | "opt2" | "shared"
    const applyGroupOptionsToRow = (rowEl, cause = "init") => {
      const g = getGroupStateFromRow(rowEl);
      if (!g) return;

      const c = getRowCache(rowEl);
      const s1 = c.s1;
      const s2 = c.s2;
      const s3 = c.s3;

      let o1 = "";
      let o2 = "";

      // OPTION 1
      if (sharedOption1Enabled) {
        const sharedVal = getSharedOption1();

        // Keep row's option1 select synced (hidden by CSS)
        if (s1) {
          // keep as a single option select (logic only)
          setSelectOptions(s1, sharedVal ? [sharedVal] : [], sharedVal);
          s1.value = sharedVal;
          s1.disabled = true;
        }
        o1 = sharedVal;
      } else {
        if (s1) {
          s1.disabled = false;

          // Only rebuild option1 list when required (init/shared). Opt1 change doesn't need a rebuild.
          if (cause === "init" || cause === "shared") {
            setSelectOptions(s1, g.maps.opt1Values, s1.value);
          }
          o1 = norm(s1.value) || g.maps.opt1Values[0] || "";
        }
      }

      // OPTION 2 + 3
      if (optCount >= 2 && s2) {
        if (cause === "opt2") {
          // Opt2 changed: only update opt3 (if any)
          o2 = norm(s2.value) || "";
        } else {
          // Opt1 / init / shared: update opt2 list based on opt1
          const allowed2 = g.maps.opt2ByOpt1.get(o1) || [];
          setSelectOptions(s2, allowed2, s2.value);
          o2 = norm(s2.value) || allowed2[0] || "";
        }

        if (optCount >= 3 && s3) {
          const key = `${o1}|||${o2}`;
          const allowed3 = g.maps.opt3ByOpt1Opt2.get(key) || [];
          setSelectOptions(s3, allowed3, s3.value);
        }
      }

      updatePrice(rowEl);
    };


    const bindRow = (rowEl) => {
      // Cache commonly used elements (big perf win on mobile)
      const c = getRowCache(rowEl);

      // Cache group pointer for fast lookups
      const groupEl = rowEl.closest(".dsc-mvp__group");
      if (groupEl && groupEl.__dscGroup) rowEl.__dscGroup = groupEl.__dscGroup;

      const onOpt1 = () => {
        state.displayRowEl = rowEl;
        applyGroupOptionsToRow(rowEl, "opt1");
        showError("");
      };

      const onOpt2 = () => {
        state.displayRowEl = rowEl;
        applyGroupOptionsToRow(rowEl, "opt2");
        showError("");
      };

      const onOpt3 = () => {
        state.displayRowEl = rowEl;
        updatePrice(rowEl);
        showError("");
      };

      if (c.s1 && !sharedOption1Enabled) c.s1.addEventListener("change", onOpt1);
      if (c.s2) c.s2.addEventListener("change", onOpt2);
      if (c.s3) c.s3.addEventListener("change", onOpt3);

      applyGroupOptionsToRow(rowEl, "init");
    };

    const syncAllRows = () => {
      const rows = qsa(groupsWrap, ".dsc-mvp__row");
      for (let i = 0; i < rows.length; i++) applyGroupOptionsToRow(rows[i], "shared");
    };

    const addRowToGroup = (g) => {
      if (!g) return;
      if (state.totalRows >= maxRowsOverall) return;
      if (g.rowsCount >= maxRowsPerGroup) return;

      const title = g.titleEl?.textContent || "Product";
      const idx = g.rowsCount;

      g.rowsWrap.insertAdjacentHTML("beforeend", rowHTML(title, idx, optCount, finalOptionLabels));
      const newRow = g.rowsWrap.lastElementChild;
      if (newRow) bindRow(newRow);

      g.rowsCount += 1;
      state.totalRows += 1;
      scheduleSetPriceRender();

      refreshRowLabelsInGroup(g);
      scheduleRefresh();

      // ensure new row gets global color synced
      if (sharedOption1Enabled) requestAnimationFrame(() => applyGroupOptionsToRow(newRow, "shared"));
    };

    const removeRow = (rowEl) => {
      if (!rowEl) return;
      if (state.totalRows <= 1) return;

      const g = getGroupStateFromRow(rowEl);
      if (!g) return;

      rowEl.remove();
      g.rowsCount = Math.max(0, g.rowsCount - 1);
      state.totalRows = Math.max(0, state.totalRows - 1);
      scheduleSetPriceRender();

      refreshRowLabelsInGroup(g);
      scheduleRefresh();
      showError("");
    };

    /* ------------------ Render groups + per-group pools ------------------ */
    groupsWrap.innerHTML = finalGroupLabels.map((t, i) => groupHTML(i, t)).join("");

    const groupEls = qsa(groupsWrap, ".dsc-mvp__group");
    for (let i = 0; i < groupEls.length; i++) {
      const el = groupEls[i];
      const titleEl = qs(el, ".dsc-mvp__group-title");
      const rowsWrap = qs(el, ".dsc-mvp__group-rows");
      const groupAddBtn = qs(el, ".dsc-mvp__group-add");

      const gName = norm(titleEl?.textContent || "");
      const rule = rules[gName] || {};
      const gVariants = filterVariantsByRule(variants, rule, optCount);
      const finalVariants = gVariants.length ? gVariants : variants;

      state.groups.push({
        el,
        titleEl,
        rowsWrap,
        groupAddBtn,
        rowsCount: 0,
        variants: finalVariants,
        vIndex: buildVariantIndex(finalVariants),
        maps: buildGroupOptionMaps(finalVariants, optCount),
      });

      // Cache group reference on DOM node for O(1) lookup
      el.__dscGroup = state.groups[state.groups.length - 1];
    }

    // Shared option1 strict intersection
    if (sharedOption1Enabled) {
      // Strict mode (as you wanted)
      if (sharedMode !== "strict") {
        // we still treat as strict for safety
      }

      const all = state.groups.map((g) => Array.isArray(g.maps?.opt1Values) ? g.maps.opt1Values : []);
      const intersection = all.reduce((acc, arr) => {
        const s = new Set(arr.map(norm).filter(Boolean));
        if (acc == null) return s;
        for (const v of Array.from(acc)) if (!s.has(v)) acc.delete(v);
        return acc;
      }, null);

      const sharedValues = intersection ? Array.from(intersection) : [];
      root.classList.add("is-shared-option1");

      if (!sharedValues.length) {
        showError("This product doesn't have a common Color across all groups. Please check variants.");
        addBtn.disabled = true;
        checkoutBtn.disabled = true;
      } else {
        // Render global pill selector before groups
        const sharedLabel = finalOptionLabels[0] || "Color";
        groupsWrap.insertAdjacentHTML("beforebegin", sharedPillsHTML(sharedLabel, sharedValues));

        const sharedSelect = qs(root, ".dsc-mvp__shared-select");
        const pillsWrap = qs(root, ".dsc-mvp__pills");

        const setActivePill = (val) => {
          const pills = qsa(pillsWrap, ".dsc-mvp__pill");
          for (let i = 0; i < pills.length; i++) {
            const isOn = norm(pills[i].dataset.value) === norm(val);
            pills[i].classList.toggle("is-active", isOn);
            pills[i].setAttribute("aria-checked", isOn ? "true" : "false");
          }
        };

        // init state
        setSelectOptions(sharedSelect, sharedValues, sharedSelect.value);
        setActivePill(sharedSelect.value);

        pillsWrap.addEventListener("click", (e) => {
          const btn = e.target.closest(".dsc-mvp__pill");
          if (!btn) return;
          e.preventDefault();
          const val = norm(btn.dataset.value);
          if (!val) return;

          sharedSelect.value = val;
          setActivePill(val);
          if (!state.displayRowEl) state.displayRowEl = qs(groupsWrap, ".dsc-mvp__row");
          syncAllRows();
          // after syncing options, sync theme with driver row
          if (state.displayRowEl) {
            const vv = getVariantForRow(state.displayRowEl);
            if (vv) setMainVariantId(vv.id);
          }
          showError("");
        });

        // keyboard support for pills (left/right arrows)
        pillsWrap.addEventListener("keydown", (e) => {
          const pills = qsa(pillsWrap, ".dsc-mvp__pill");
          if (!pills.length) return;

          const currentVal = norm(sharedSelect.value);
          let idx = pills.findIndex((p) => norm(p.dataset.value) === currentVal);
          if (idx < 0) idx = 0;

          if (e.key === "ArrowRight" || e.key === "ArrowDown") {
            e.preventDefault();
            idx = (idx + 1) % pills.length;
            pills[idx].focus();
            pills[idx].click();
          } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
            e.preventDefault();
            idx = (idx - 1 + pills.length) % pills.length;
            pills[idx].focus();
            pills[idx].click();
          }
        });

        requestAnimationFrame(() => syncAllRows());
      }
    }

    // Render default rows
    for (let gi = 0; gi < state.groups.length; gi++) {
      const g = state.groups[gi];
      if (!g.rowsWrap) continue;

      const rowsToAdd = Math.max(1, defaultRowsPerGroup);
      const title = g.titleEl?.textContent || "Product";

      for (let r = 0; r < rowsToAdd; r++) {
        if (state.totalRows >= maxRowsOverall) break;
        if (g.rowsCount >= maxRowsPerGroup) break;

        g.rowsWrap.insertAdjacentHTML("beforeend", rowHTML(title, g.rowsCount, optCount, finalOptionLabels));
        const rowEl = g.rowsWrap.lastElementChild;
        if (rowEl) bindRow(rowEl);

        g.rowsCount += 1;
        state.totalRows += 1;
      }

      refreshRowLabelsInGroup(g);
    }

    refreshRemoveAvailability();
    refreshAddAvailability();

    // Initial sync (first row drives)
    state.displayRowEl = qs(groupsWrap, ".dsc-mvp__row");
    if (state.displayRowEl) {
      const v0 = getVariantForRow(state.displayRowEl);
      if (v0) setMainVariantId(v0.id);
    }

    groupsWrap.addEventListener("click", (e) => {
      const groupAddBtn = e.target.closest(".dsc-mvp__group-add");
      if (groupAddBtn) {
        e.preventDefault();
        const groupEl = groupAddBtn.closest(".dsc-mvp__group");
        const g = state.groups.find((x) => x.el === groupEl);
        addRowToGroup(g);
        return;
      }

      const rowAddBtn = e.target.closest(".dsc-mvp__row-add");
      if (rowAddBtn) {
        e.preventDefault();
        const groupEl = rowAddBtn.closest(".dsc-mvp__group");
        const g = state.groups.find((x) => x.el === groupEl);
        addRowToGroup(g);
        return;
      }

      const removeBtn = e.target.closest(".dsc-mvp__remove");
      if (removeBtn) {
        e.preventDefault();
        removeRow(removeBtn.closest(".dsc-mvp__row"));
      }
    });

    
    // Render custom fields (from product tags + fields presets), below MVP and above action buttons if possible
    const actionsAnchor = addBtn.closest(".dsc-mvp__actions") || addBtn.parentElement;
    dscRenderCustomFields(root, actionsAnchor);

/* ------------------ Add to cart (with loader) ------------------ */
    let isAdding = false;

    async function submit(goCheckout, clickedBtn) {
      if (isAdding) return;
      isAdding = true;

      setBtnLoading(clickedBtn, true);
      addBtn.disabled = true;
      checkoutBtn.disabled = true;
      showError("");

      try {
        const rows = qsa(groupsWrap, ".dsc-mvp__row");
        if (!rows.length) throw new Error("Select at least one product option.");

        // Validate & collect custom fields (line-item properties) if enabled
        const cfValid = dscValidateCustomFields(root);
        if (!cfValid.ok) throw new Error("Please fill the required customisation fields.");
        const customProps = dscCollectCustomFieldProperties(root);
        const nativeFiles = dscCollectNativeFiles(root);

        const items = rows.map((rowEl) => {
          const v = getVariantForRow(rowEl);
          if (!v) throw new Error("Please select valid options.");
          if (!v.available) throw new Error("One of the selected variants is unavailable.");

          const groupEl = rowEl.closest(".dsc-mvp__group");
          const groupTitle = norm(qs(groupEl, ".dsc-mvp__group-title")?.textContent || "Item");
          const idx = Number(rowEl.dataset.row || 0) + 1;

          return {
            id: v.id,
            quantity: 1,
            properties: {
              Group: groupTitle,
              Item: `${groupTitle} ${idx}`,
              ...customProps,
            },
            files: nativeFiles,
          };
        });

        for (let i = 0; i < items.length; i++) {
          await addSingleVariantWithRetry(items[i], { maxRetries: 4 });
          await sleep(120);
        }

        window.location.href = window.Shopify.routes.root + (goCheckout ? "checkout" : "cart");
      } catch (err) {
        showError(err?.message || "Could not add items to cart.");
      } finally {
        isAdding = false;
        setBtnLoading(clickedBtn, false);
        addBtn.disabled = false;
        checkoutBtn.disabled = false;
      }
    }

    addBtn.addEventListener("click", () => submit(false, addBtn));
    checkoutBtn.addEventListener("click", () => submit(true, checkoutBtn));
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".dsc-mvp").forEach(init);
  });
})();
